import * as t from 'io-ts';

export const BackgroundAttachment = t.type({
    key: t.union([t.string, t.null]), // "119113237952379665.png"
    url: t.union([t.string, t.null]),  // (pre-signed) "https://stage-archipad-services-fr.s3.amazonaws.com...."
});
export type BackgroundAttachment = t.TypeOf<typeof BackgroundAttachment>;